import { playBoosterBuyPremium, playBoosterBuyRegular } from '@wg/web2clientapi/sound';
import get from 'lodash/get';
import log from 'loglevel';

import type Api from '~/types';
import type { Thunk } from '~/store';

import {
    setBuyBoosterPendingState as appSliceSetBuyBoosterPendingState,
    switchSync as appSliceSwitchSync,
    updateAccount,
} from '~/store/app';
import {
    closeMultipleBuyDialog as dialogsSliceCloseMultipleBuyDialog,
    closeStartBuyDialog as dialogsSliceCloseStartBuyDialog,
} from '~/store/dialogs';
import { showErrorMessage } from '~/store/client';
import api from '~/api';
import { armoryHideSpinner, armoryShowSpinner } from '~/armory';
import { BUY_BOOSTER_SOURCE } from '~/constants';


export const waitForTransactionsComplete = (): Thunk => (dispatch, getState) => {
    const interval = setInterval(() => {
        const state = getState();
        if (!state.app.account.pendingTransactions) {
            armoryHideSpinner();
            clearInterval(interval);
        }
    }, 1000);
};


export const buyBooster = (): Thunk => (dispatch, getState) => {
    dispatch(appSliceSetBuyBoosterPendingState(true));

    const state = getState();
    const buyingBooster = state.app.selectedBooster;

    let source = BUY_BOOSTER_SOURCE.DOCKYARD;
    if (state.app.isInIframe) {
        armoryShowSpinner();
        source = BUY_BOOSTER_SOURCE.ARMORY;
    }

    dispatch(appSliceSwitchSync(false));

    api.post('/accounts/buy-booster/', {
        boosterId: buyingBooster?.id,
        count: 1,
        source,
    })
        .then((resp: Api.Account) => {
            dispatch(dialogsSliceCloseStartBuyDialog());
            if (resp) {
                dispatch(updateAccount(resp));

                if (buyingBooster?.isPremium) {
                    playBoosterBuyPremium();
                } else {
                    playBoosterBuyRegular();
                }
                if (get(resp, 'pendingTransactions', false)) {
                    dispatch(waitForTransactionsComplete());
                }
            } else {
                armoryHideSpinner();
            }
        })
        .catch((error: Error) => {
            log.error(error);
            dispatch(showErrorMessage(error));
        })
        .finally(() => {
            dispatch(appSliceSwitchSync(true));
            dispatch(appSliceSetBuyBoosterPendingState(false));
        });
};


export const buyBoosters = (isPremium: boolean): Thunk => (dispatch, getState) => {
    const state = getState();
    const premiumBooster = state.app.boosters.filter((booster) => booster.isPremium && !booster.unique)[0];
    const regularBooster = state.app.boosters.filter((booster) => !booster.isPremium && !booster.unique)[0];
    const booster = isPremium ? premiumBooster : regularBooster;
    const eventum = get(state.app, 'account.wallet.eventum', 0) as number;
    const count = isPremium ? state.app.predictProgress : eventum;
    const pendingTransactions: boolean = get(state.app, 'account.pendingTransactions', false);

    if (count > 0 && !pendingTransactions) {
        if (isPremium) {
            dispatch(appSliceSetBuyBoosterPendingState(true));
        }
        dispatch(appSliceSwitchSync(false));
        api.post('/accounts/buy-booster/', {
            boosterId: booster.id,
            count,
        })
            .then((resp: Api.Account) => {
                dispatch(updateAccount(resp));
                if (isPremium) {
                    playBoosterBuyPremium();
                } else {
                    playBoosterBuyRegular();
                }
            })
            .catch((error: Error) => {
                log.error(error);
                dispatch(showErrorMessage(error));
            })
            .finally(() => {
                dispatch(appSliceSwitchSync(true));
                dispatch(dialogsSliceCloseMultipleBuyDialog());
                dispatch(appSliceSetBuyBoosterPendingState(false));
            });
    }
};
